import React, { useState, useEffect } from "react";
import { Terminal, Shield, Cpu, Activity } from "lucide-react";

interface LoadingHUDProps {
  targetUrl: string;
}

export const LoadingHUD: React.FC<LoadingHUDProps> = ({ targetUrl }) => {
  const [progress, setProgress] = useState(12);
  const [logs, setLogs] = useState<string[]>([
    "INITIALIZING QUANTUM NETWORK SOCKET...",
    `RESOLVING TARGET HOST: ${targetUrl}`,
  ]);

  useEffect(() => {
    const logSequence = [
      "DISPATCHING ASYNC FETCH HANDSHAKE...",
      "MEASURING TIME TO FIRST BYTE (TTFB)...",
      "PARSING DOCUMENT AST & HEADERS...",
      "EVALUATING TITLE & META DESCRIPTION CONSTRAINTS...",
      "INSPECTING OPEN GRAPH & TWITTER CARD PROTOCOLS...",
      "EXTRACTING STRUCTURED DATA (JSON-LD & MICRODATA)...",
      "AUDITING IMAGE ALT ATTRIBUTES & LAZY LOADING...",
      "CHECKING ROBOTS.TXT & SITEMAP.XML AT DOMAIN ROOT...",
      "SYNTHESIZING LIGHTHOUSE & SEO AUDIT DIAGNOSTICS...",
    ];

    let currentStep = 0;

    const interval = setInterval(() => {
      if (currentStep < logSequence.length) {
        setLogs((prev) => [...prev, logSequence[currentStep]]);
        setProgress((prev) => Math.min(96, prev + 10));
        currentStep++;
      } else {
        clearInterval(interval);
      }
    }, 280);

    return () => clearInterval(interval);
  }, [targetUrl]);

  return (
    <div className="cyber-card hud-loader">
      <div className="radar-spinner">
        <div className="radar-center-text">{progress}%</div>
      </div>

      <h2 style={{ fontSize: "1.2rem", marginBottom: "0.5rem", color: "var(--neon-cyan)" }}>
        QUANTUM MATRIX AUDIT IN PROGRESS
      </h2>
      <p style={{ color: "var(--text-secondary)", fontSize: "0.85rem", marginBottom: "1.5rem" }}>
        Target Host: <span style={{ color: "var(--neon-emerald)", fontFamily: "var(--font-mono)" }}>{targetUrl}</span>
      </p>

      <div className="hud-log-box">
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0.5rem", paddingBottom: "0.4rem", borderBottom: "1px solid rgba(0,243,255,0.15)", color: "var(--neon-cyan)" }}>
          <span style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
            <Terminal size={14} /> LIVE CONSOLE FEED
          </span>
          <span style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
            <Activity size={14} /> REALTIME
          </span>
        </div>

        {logs.slice(-5).map((log, i) => (
          <div key={i} className="hud-log-line">
            <span className="hud-timestamp">[{new Date().toLocaleTimeString()}]</span>
            <span>{log}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
